import { FeatureFlag } from '@redux/modules/featureFlags/reducer';
import store from 'services/store';
import { RootState } from 'types/state';

// This is to help removal of old featureFlag ids later on. Unfortunately,
// TypeScript doesn't support converting JSON options to a const assertion in
// order for us to build types off of the ids. This is the alternative.
export type FeatureFlagIds = 'EN-4733' | 'EN-5301'

export const ff = (flags: FeatureFlag[] = []) => {
  const fetch = () => ff((store.getState() as RootState).featureFlags);
  const getFlag = (id: FeatureFlagIds): FeatureFlag | undefined => flags.find((flag) => flag.id === id);
  const getActive = (id: FeatureFlagIds): boolean => flags.find((flag) => flag.id === id)?.isActive ?? false;

  const api = {
    fetch,
    getFlag,
    getActive,
  };

  return api;
};
